var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-panel",class:_vm.panelClass},[_c('header',{on:{"click":_vm.togglePanel}},[_c('span'),_vm._v(_vm._s(_vm.headerTitle)+"\n  ")]),_c('article',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }